import {
   ADD_ISSUE_INVENTORY,
   UPDATE_ISSUE_INVENTORY,
   GET_ISSUE_INVENTORY,
   GET_ISSUES_INVENTORY,
   DELETE_ISSUE_INVENTORY,
   EMPTY_ONE_ISSUE_INVENTORY,
   GET_LAST_ISSUE_DAYBOOK,
   GET_ISSUE_INVENTORY_PREV_AND_NEXT,
   GET_SINGLE_ISSUES_INVENTORY,
} from '../types';

const initialState = {
   list: [],
   single: null,
   totalCount: 0,
   lastBill: null,
   isLoading: false,
   pagination: {
      limit: 10,
      nextPage: null,
      totalPages: 1,
      currentPage: 1,
      hasNextPage: false,
      previousPage: null,
      totalProducts: 0,
      hasPreviousPage: false,
   },
   prevAndNext: null,
   issueData: null,
};

const reducer = (state = initialState, { type, payload }) => {
   switch (type) {
      case 'SET_LOADING':
         return { ...state, isLoading: payload };

      case GET_ISSUES_INVENTORY:
         return {
            ...state,
            list: payload.data,
            totalCount: payload.totalCount,
            pagination: payload.pagination,
            isLoading: false,
         };

      case GET_ISSUE_INVENTORY:
         return { ...state, single: payload || initialState.single, isLoading: false };

      case UPDATE_ISSUE_INVENTORY:
         return {
            ...state,
            list: state.list.map((item) => (item.id === payload.id ? payload : item)),
            isLoading: false,
         };

      case ADD_ISSUE_INVENTORY:
         return {
            ...state,
            list: [payload, ...state.list],
            totalCount: state.totalCount + 1,
            isLoading: false,
         };

      case DELETE_ISSUE_INVENTORY:
         return {
            ...state,
            list: state.list.filter((item) => item.id !== payload.id),
            totalCount: state.totalCount - 1,
            isLoading: false,
         };

      case GET_LAST_ISSUE_DAYBOOK:
         return {
            ...state,
            lastIssueDaybook: payload,
         };

      case GET_ISSUE_INVENTORY_PREV_AND_NEXT:
         return {
            ...state,
            prevAndNext: payload,
         };

      case GET_SINGLE_ISSUES_INVENTORY:
         return {
            ...state,
            issueData: { data: payload.data, pagination: payload.pagination, totalCount: payload.totalCount },
         };

      case EMPTY_ONE_ISSUE_INVENTORY:
         return { ...state, single: initialState.single };

      default:
         return state;
   }
};

export default reducer;
